import axios from 'axios';
import { CreateBreedRequest, UpdateBreedRequest } from '../../structures/requests/breed';
import { Breed, BreedSelect } from '../../structures/models/breed';
import { Media } from '../../structures/models/media/media';
import { CreateMediaRequest } from '../../structures/requests/media';
import { ApiV1Response } from '../../structures/responses/axios';
import routes from '../routes';

// eslint-disable-next-line import/prefer-default-export
export const createBreed = async (request:CreateBreedRequest): Promise<Breed> => {
  const response = await axios.post(routes.API_BREED_POST, request, { headers: { Accept: 'application/json' } });
  return response.data.data;
};

export const updateBreed = async (request: UpdateBreedRequest, breedId: number): Promise<Breed> => {
  const response = await axios.put(routes.apiBreedUpdate(breedId), request, { headers: { Accept: 'application/json' } });
  return response.data.data;
};

export const getBreed = async (breedId: number): Promise<Breed> => {
  const response = await axios.put(routes.apiBreedGet(breedId), { headers: { Accept: 'application/json' } });
  return response.data.data;
};

// TODO add to this where necessary
export const uploadBreedMedia = async (breedId: number, media: CreateMediaRequest):
  Promise<Media | string> => {
  const response = await axios.post(routes.apiUploadBreedMedia(breedId), media, { headers: { Accept: 'application/json' } });
  return response.data.data;
};

// Get an array of breeds for use in react AsyncSelect components
export const getBreedSelect = async (inputValue?: string): Promise<BreedSelect[]> => {
  const res: ApiV1Response<Breed[]> = await axios.get(routes.API_BREED_INDEX, {
    params: {
      search: inputValue,
    },
  });

  const breeds = res.data.data;

  return breeds.map((breed) => {
    return {
      value: breed.id,
      label: breed.name,
    };
  }).sort((a, b) => {
    return (a.label < b.label) ? -1 : 1;
  });
};

/**
 * Deletes a selected breed;
 * be advised that only admin level users can delete breeds.
 * @param breedId
 */
export const deleteBreed = async (breedId: number): Promise<void> => {
  const response = await axios.delete(routes.apiBreedDelete(breedId));
};
